import Vue from "vue";
import Vuex from "vuex";

import breadcrumbs from "./breadcrumbs.module";
import config from "./config.module";
import htmlClass from "./htmlclass.module";
import home from "./home.module";
import loading from "./loading.module";
import rolePermission from "./role-permission.module";
import devOps from "./dev-ops.module";
import auth from "./auth.module";
import listApi from "./list-api.module";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    config,
    breadcrumbs,
    htmlClass,
    home,
    loading,
    rolePermission,
    devOps,
    auth,
    listApi,
  },
});
